const module = {
    config: {
      name: "profile",
      icon: 'user-search',
      desc: "User list",
      layout: true,
      hidden : true,
      order: 10,
    },
    routes: [
      {
        name: 'Profile',
        icon: 'profile',
        path: '/user-profile',
        translate_key: 'user_profile',
        component: () => import('./profile.vue'),
      }
    ]
  };
  export default module;
  


// WEBPACK FOOTER //
// ./src/modules/profile/_index.js